import {openDb} from "../../../Services/BrowserDatabaseIDB";
import {ensureStoresExist, mergeChanged} from "../../../Services/BrowserDatabaseFunctions";

export function addEventIdea(_event_id, _idea){

    return openDb('pa', 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction('Events', 'readwrite');
            const dataStore = tx.objectStore('Events');

            // Get the events array by key "Events"
            return dataStore.get('Events').then(eventsArray => {
                if (!eventsArray) {
                    eventsArray = [];
                }

                // Find the event by ID
                const eventIndex = eventsArray.findIndex(event => event.id === _event_id);

                if (eventIndex !== -1) {
                    // Get the specific event
                    const event = eventsArray[eventIndex];

                    // ensure ideas is an array
                    const ideas = Array.isArray(event.ideas) ? event.ideas : [];

                    // prefer matching by id; fall back to temp_id if you use client placeholders
                    const idx = ideas.findIndex(m =>
                        (m && _idea && (
                            (m.id != null && _idea.id != null && String(m.id) === String(_idea.id))
                        ))
                    );

                    if (idx >= 0) {
                        // update existing idea; merge only defined fields to avoid overwriting with undefined
                        const patch = _idea;
                        const base = ideas[idx];
                        const merged = { ...base };
                        Object.keys(patch).forEach(k => {
                            if (typeof patch[k] !== 'undefined') merged[k] = patch[k];
                        });
                        ideas[idx] = merged;
                    } else {
                        // add new idea
                        ideas.push(_idea);
                    }

                    // write back
                    event.ideas = ideas;
                    eventsArray[eventIndex] = event;

                    // Put the updated events array back into the object store
                    return dataStore.put(eventsArray, 'Events').then(() => {
                        console.log(`Idea with ID ${_idea.id} in Event with ID ${_event_id} added/updated successfully.`);
                        return true;
                    });
                } else {
                    console.error(`Event with ID ${_event_id} not found.`);
                    return false;
                }
            });
        }).catch(function (error) {
            console.error("An error occurred:", error);
            throw error; // Re-throw the error to be caught by the caller
        });
}
export function updateEventIdea(_event_id, _idea){

    return openDb('pa', 1, ensureStoresExist).then(function (db) {
        const tx = db.transaction('Events', 'readwrite');
        const dataStore = tx.objectStore('Events');

        // Get the events array by key "Events"
        return dataStore.get('Events').then(eventsArray => {
            if (!eventsArray) {
                eventsArray = [];
            }

            // Find the event by ID
            const eventIndex = eventsArray.findIndex(event => event.id === _event_id);

            if (eventIndex !== -1) {

                // Get the specific event
                const event = eventsArray[eventIndex];

                // ensure ideas is an array
                const ideas = Array.isArray(event.ideas) ? event.ideas : [];

                // prefer matching by id; fall back to temp_id if you use client placeholders
                const idx = ideas.findIndex(m =>
                    (m && _idea && (
                        (m.id != null && _idea.id != null && String(m.id) === String(_idea.id))
                    ))
                );

                if (idx >= 0) {
                    const { merged, changed } = mergeChanged(ideas[idx], _idea);
                    if (changed) ideas[idx] = merged;
                } else {
                    // add new idea
                    ideas.push(_idea);
                }

                // write back
                event.ideas = ideas;
                eventsArray[eventIndex] = event;

                // Put the updated events array back into the object store
                return dataStore.put(eventsArray, 'Events').then(() => {
                    console.log(`Idea with ID ${_idea.id} in Event with ID ${_event_id} added/updated successfully.`);
                    return true;
                });
            } else {
                console.error(`Event with ID ${_event_id} not found.`);
                return false;
            }
        });
    }).catch(function (error) {
        console.error("An error occurred:", error);
        throw error; // Re-throw the error to be caught by the caller
    });
}

export function addEventIdeaComment(_event_id, _idea_id, _message) {
    console.log("addEventIdeaComment");

    return openDb('pa', 1, ensureStoresExist)
        .then(function (db) {
        const tx = db.transaction('Events', 'readwrite');
        const dataStore = tx.objectStore('Events');

        return dataStore.get(_event_id).then(event => {
            if (!event) {
                console.error(`Event with ID ${_event_id} not found.`);
                return false;
            }

            const ideas = Array.isArray(event.ideas) ? event.ideas : [];

            // 2. Find the specific idea within the event
            // Note: using == to handle potential string/number mismatches from server
            const ideaIndex = ideas.findIndex(idea => idea.id === _idea_id);

            if (ideaIndex !== -1) {
                console.log("Found the IDEA");
                const idea = ideas[ideaIndex];
                if (!idea.comments) idea.comments = [];

                // 3. Check if the message/comment already exists
                // We check by comment_id (server-side) OR temp_id (client-side)
                const exists = idea.comments.some(c =>
                    (c.comment_id === _message.comment_id) ||
                    (c.temp_id === _message.temp_id)
                );

                if (!exists) {
                    // Add the new message
                    idea.comments.push(_message);
                    console.log("New comment added to IndexedDB");
                } else {
                    // Optional: Update existing message (e.g., mark as sent_to_server)
                    const existingIndex = idea.comments.findIndex(c =>
                        c.comment_id === _message.comment_id || c.temp_id === _message.temp_id
                    );
                    idea.comments[existingIndex] = { ...idea.comments[existingIndex], ..._message };
                    console.log("Existing comment updated in IndexedDB");
                }

                // 4. Update the arrays and write back
                ideas[ideaIndex] = idea;
                event.ideas = ideas;

                const sanitizedEvent = JSON.parse(JSON.stringify(event));

                return dataStore.put(sanitizedEvent).then(() => {
                    console.log(`Successfully updated IndexedDB for Idea: ${_idea_id}`);
                    return true;
                });

            } else {
                console.error(`Idea ${_idea_id} not found in Event ${_event_id}`);
                return false;
            }

        });
    }).catch(function (error) {
        console.error("IndexedDB Error:", error);
        throw error;
    });
}

export function deleteEventIdea(_event_id, _idea_id) {
    return openDb('pa', 1, ensureStoresExist).then(function (db) {
        const tx = db.transaction('Events', 'readwrite'); // Use 'readwrite' mode for updates
        const dataStore = tx.objectStore('Events');

        // Get the events array by key "Events"
        return dataStore.get('Events').then(eventsArray => {
            if (!eventsArray) {
                eventsArray = [];
            }

            // Find the event by ID
            const eventIndex = eventsArray.findIndex(event => event.id === _event_id);

            if (eventIndex !== -1) {
                // Get the specific event
                const event = eventsArray[eventIndex];

                // Filter out the idea with the specified ID
                // Update the event with the modified ideas array
                event.ideas = event.ideas.filter(idea => idea.id !== _idea_id);

                // Update the event in the events array
                eventsArray[eventIndex] = event;

                // Put the updated events array back into the object store
                return dataStore.put(eventsArray, 'Events').then(() => {
                    console.log(`Idea with ID ${_idea_id} in Event with ID ${_event_id} deleted successfully.`);
                    return true;
                });
            } else {
                console.error(`Event with ID ${_event_id} not found.`);
                return false;
            }
        });
    }).catch(function (error) {
        console.error("An error occurred:", error);
        throw error; // Re-throw the error to be caught by the caller
    });
}
